const icon = require('vue-svgicon');
icon.register({
    'list': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path pid="0" d="M30.405 27.62H9.006a1.596 1.596 0 010-3.194h21.399a1.596 1.596 0 010 3.194zM30.405 17.598H9.006a1.596 1.596 0 010-3.193h21.399a1.596 1.596 0 010 3.193zM30.405 7.574H9.006a1.596 1.596 0 010-3.194h21.399a1.596 1.596 0 010 3.194zM4.288 6.101c0 1.185-.959 2.144-2.144 2.144S0 7.286 0 6.101s.959-2.144 2.144-2.144 2.144.959 2.144 2.144zM4.288 16c0 1.185-.959 2.144-2.144 2.144a2.143 2.143 0 110-4.288c1.185 0 2.144.961 2.144 2.144zM4.288 25.9A2.143 2.143 0 110 25.9a2.145 2.145 0 114.288 0z"/>`,
    },
});
